import mongoose from 'mongoose';

export enum ENewCollectionSectionStatus {
  inactive,
  active
}

export interface INewCollectionSection {
  leftSideImage: mongoose.Schema.Types.ObjectId;
  rightSideImage: mongoose.Schema.Types.ObjectId;
  subTitleVi: string;
  titleVi: string;
  descriptionVi: string;
  buttonLabelVi: string;
  buttonLink: string;
  status: ENewCollectionSectionStatus;
}
